import { type FC } from 'react';
import classnames from 'classnames';

import dibsCss from 'dibs-css';

import shimmerStyles from '../CartShimmers/CartItemCardShimmer.scss';

export const CartTotalsShimmer: FC = () => {
    return (
        <>
            <div className={classnames(shimmerStyles.row, dibsCss.mbXsmall)} />
            <div className={classnames(shimmerStyles.row, dibsCss.mbXsmall)} />
            <div className={classnames(shimmerStyles.row, dibsCss.mbXsmall)} />
            <div className={classnames(shimmerStyles.row, dibsCss.mbXsmall)} />
            <div className={classnames(shimmerStyles.button, dibsCss.mtMedium)} />
        </>
    );
};
